module.exports = __webpack_public_path__ + "img/gb_xhs_2wm.1a7b2c5.svg";